module.exports = __webpack_public_path__ + "static/media/googlepay.e32ea2a5.svg";